/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */


(function (M, _, $, Backbone) {
  "use strict";

  M.Model = M.Model || {};
  M.Model.Design = M.Model.Design || {};

  /**
   * @class M.Model.Design.PollVote
   *
   */
  M.Model.Design.PollVote = Backbone.Model.extend({
    initialize: function(){
      this.urlRoot = this.get('urlPaths')['designPollVoteCreateUrlName'];
    }
  });

})(M, _, $, Backbone);

